import { handleActions } from "redux-actions";
import {
  BOOKUPDATE,
  BOOKUPDATE_SUCCESS,
  BOOKUPDATE_FAILURE,
  BOOKUPDATE_INIT,
  BOOKUPDATE_BATCH,
  BOOKUPDATE_BATCH_SUCCESS,
  BOOKUPDATE_BATCH_FAILURE,
  BOOKUPDATE_BATCH_INIT
} from "../actionCreators";

const initialState = {
  result: null,
  bookUpdateError: null,
  isBookUpdating: false,
  isBookUpdated: false
};

const bookUpdateReducer = handleActions(
  {
    [BOOKUPDATE]: state => ({
      ...state,
      isBookUpdating: true
    }),
    [BOOKUPDATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      bookUpdateError: null,
      result: data.result,
      isBookUpdating: false,
      isBookUpdated: true
    }),
    [BOOKUPDATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      bookUpdateError: error,
      isBookUpdating: false,
      isBookUpdated: false
    }),
    // 초기화
    [BOOKUPDATE_INIT]: state => ({
      ...state,
      result: null,
      bookUpdateError: null,
      isBookUpdating: false,
      isBookUpdated: false
    }),

    // 묶음 일괄 처리는 같은 isBookUpdating / isBookUpdated 플래그를 공유.
    // BookDetailContainer 의 useEffect(isBookUpdated → 목록 이동)가 단권/묶음 둘 다 같은 동작.
    [BOOKUPDATE_BATCH]: state => ({
      ...state,
      isBookUpdating: true
    }),
    [BOOKUPDATE_BATCH_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      bookUpdateError: null,
      result: data.result,
      isBookUpdating: false,
      isBookUpdated: true
    }),
    [BOOKUPDATE_BATCH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      bookUpdateError: error,
      isBookUpdating: false,
      isBookUpdated: false
    }),
    [BOOKUPDATE_BATCH_INIT]: state => ({
      ...state,
      result: null,
      bookUpdateError: null,
      isBookUpdating: false,
      isBookUpdated: false
    })
  },
  initialState
);

export default bookUpdateReducer;
